import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { CompanySettings } from "../settings/settings.interface";
import { CompanyFontUploadResult } from "./company.interface";

@Injectable({ providedIn: "root" })
export class CompanyService {
  constructor(private http: HttpClient) {}

  get = (): Observable<CompanySettings> =>
    this.http.get<CompanySettings>("/company");

  save = (companySettings: CompanySettings): Observable<unknown> =>
    this.http.post("/company", companySettings);

  upload = (file: File): Observable<unknown> => {
    const form = new FormData();
    form.append("image", file);
    return this.http.post(`/company/photo`, form);
  };

  uploadFont = (file: File): Observable<CompanyFontUploadResult> => {
    const form = new FormData();
    form.append("font", file);
    return this.http.post<CompanyFontUploadResult>(`/company/fonts`, form);
  };

  clearFont = (): Observable<CompanySettings> =>
    this.http.delete<CompanySettings>(`/company/fonts`);
}
